import {ApolloClient, InMemoryCache, ApolloLink, HttpLink} from '@apollo/client';
import fetch from 'cross-fetch';
import {graphAPIPath} from 'js/tool/APIProvider';

export function getEContractClient(operationName) {
	const authMiddleware = new ApolloLink(async (operation, forward) => {
		operation.setContext(({headers = {}}) => ({
			headers: {
				...headers,
				'X-GRAPH-OPERATION-NAME': operationName,
			},
		}));

		return forward(operation);
	});

	return new ApolloClient({
		fetch,
		cache: new InMemoryCache(),
		link:  ApolloLink.from([authMiddleware, new HttpLink({uri: graphAPIPath})]),
	});
}
